import { useNavigate } from "react-router-dom";

import useUser from "../../profile/useUser";
import { PROFILE_PATH } from "../navItems";

const ProfileAvatar = () => {
  const navigate = useNavigate();
  const { avatarSrc, displayName } = useUser();

  return (
    <button
      type="button"
      className="sy-nav-avatar"
      onClick={() => navigate(PROFILE_PATH)}
      title={displayName}
      aria-label={displayName}
    >
      <img src={avatarSrc} alt="" />
    </button>
  );
};

export default ProfileAvatar;
